import React from "react";
import { useI18n } from "../lib/i18n";
import useTitle from "../lib/useTitle";

export default function Legal({ pageKey }) {
  const { t } = useI18n();
  const data = t.legal[pageKey];
  useTitle(data?.title);
  if (!data) return null;
  return (
    <main className="container-x py-20 max-w-3xl" data-testid={`legal-${pageKey}`}>
      <span className="eyebrow">{t.footer.legal}</span>
      <h1 className="font-serif text-4xl sm:text-5xl tracking-tighter mt-4 mb-10">{data.title}</h1>
      <div className="prose prose-lg max-w-none text-wostel-ink/80 leading-relaxed whitespace-pre-line">
        {data.body}
      </div>
    </main>
  );
}
